import { getAll as getAllProduit } from '@/api/produit/index';
import { CATEGORIE_UNITAIRE, CATEGORIE_ECRAN_NUMERIQUE } from '@/configuration/catalogue/produitConf';

export async function syncAddMateriel(contrat) {
  if (!contrat) return;
  if (!contrat.contratsProduits) contrat.contratsProduits = [];
  const filteredMat = contrat.contratsMateriels.filter(cm => cm.isNew);
  const newProduitIds = filteredMat.map(m => {
    return !m.materiel.numerique
      ? m.materiel.faces.map(f => f.produitId)
      : m.materiel.produitId;
  }).flat(3);
  const newProduits = (
    await getAllProduit({ query: { ids: newProduitIds } })
  ).data.result.items;
  const newContratsProduits = newProduitIds.map(nwp => {
    const pdt = { produitId: nwp };
    const pdtProduit = newProduits.find(p => p.id === nwp);
    if (pdtProduit) pdt.produit = pdtProduit;
    return pdt;
  });
  contrat.contratsProduits = [...contrat.contratsProduits, ...newContratsProduits];
  contrat.contratsMateriels.forEach(cm => {
    if (cm.isNew) delete cm.isNew;
  });
}

export function syncDeleteMateriel(contrat) {
  if (!contrat) return;
  if (!contrat.contratsProduits) contrat.contratsProduits = [];
  const syncProduitIds = contrat.contratsMateriels.map(m => {
    return !m.materiel.numerique
      ? m.materiel.faces.map(f => f.produitId)
      : m.materiel.produitId;
  }).flat(3);
  const newProduitIds = contrat.contratsProduits.filter(p => {
    return syncProduitIds.includes(p.produitId)
      || ![CATEGORIE_ECRAN_NUMERIQUE, CATEGORIE_UNITAIRE]
        .includes(p.produit?.supportCommercial?.categorieVente);
  });
  contrat.contratsProduits = newProduitIds;
}
